
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import type { ExtraInfoEntry } from '../ExtraInfo.vue';
import { resizeDirective } from 'v-resize-observer';
import { DirectiveOptions } from 'vue/types/options';

@Component({
  directives: {
    Resize: resizeDirective as DirectiveOptions,
  },
})
export default class TextInput extends Vue {
  @Prop({ required: true })
  readonly entry!: ExtraInfoEntry;
  @Prop({ required: true })
  readonly labelMinWidth!: number;

  get textInput(): string {
    return this.entry.textInput ?? '';
  }

  set textInput(value: string) {
    this.$set(this.entry, 'textInput', value); //set reactively, works even if property did not exist previously
  }

  get uid(): any {
    return this._uid;
  }

  labelResized(size: { width: number, height: number }, target: Element) {
    this.$emit('labelResized', size);
  }
}
